module.exports = __webpack_public_path__ + "img/图片6.4da46484.png";